import { Credits } from "./credits";
import { InternalItem } from "./internalItem";

export class Item extends Credits {
  [key: string]: any;
  part: Partial<InternalItem> = {} as Partial<InternalItem>;
  isEditable?: boolean = false;
}
